import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class ColorRadios extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let colorArray = this.props.initData ? this.props.initData : [];
		this.state = {
      d: colorArray.includes('d'),
      e: colorArray.includes('e'),
      f: colorArray.includes('f'),
      g: colorArray.includes('g'),
      h: colorArray.includes('h'),
      i: colorArray.includes('i'),
      j: colorArray.includes('j'),
      k: colorArray.includes('k'),
      l: colorArray.includes('l'),
      m: colorArray.includes('m'),
    };
	}

	componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.resetElement != prevProps.resetElement) {
      this.resetData();
    }
  }

  resetData() {

    let colorArray = this.props.initData ? this.props.initData : [];
    this.setState({
      d: colorArray.includes('d'),
      e: colorArray.includes('e'),
      f: colorArray.includes('f'),
      g: colorArray.includes('g'),
      h: colorArray.includes('h'),
      i: colorArray.includes('i'),
      j: colorArray.includes('j'),
      k: colorArray.includes('k'),
      l: colorArray.includes('l'),
      m: colorArray.includes('m'),
    });
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  concatValues() {
    let returnArray = [];
    for (const key in this.state) {
      if(this.state[key]) {
        returnArray.push(key.toUpperCase());
      }
    }
    if(returnArray.join(',').length) {
      return [ returnArray.join(',') ];
    } else {
      return [ Object.keys(this.state).join(',') ];
    }
  }

  toggleColor(color) {

    if(color == 'd') {
      this.setState({ d: !this.state.d }, () => {
        this.props.refreshData('diamonds', ['color'], this.concatValues());
      });
    } else if(color == 'e') {
      this.setState({ e: !this.state.e }, () => {
        this.props.refreshData('diamonds', ['color'], this.concatValues());
      });
    } else if(color == 'f') {
      this.setState({ f: !this.state.f }, () => {
        this.props.refreshData('diamonds', ['color'], this.concatValues());
      });
    } else if(color == 'g') {
      this.setState({ g: !this.state.g }, () => {
        this.props.refreshData('diamonds', ['color'], this.concatValues());
      });
    } else if(color == 'h') {
      this.setState({ h: !this.state.h }, () => {
        this.props.refreshData('diamonds', ['color'], this.concatValues());
      });
    } else if(color == 'i') {
      this.setState({ i: !this.state.i }, () => {
        this.props.refreshData('diamonds', ['color'], this.concatValues());
      });
    } else if(color == 'j') {
      this.setState({ j: !this.state.j }, () => {
        this.props.refreshData('diamonds', ['color'], this.concatValues());
      });
    } else if(color == 'k') {
      this.setState({ k: !this.state.k }, () => {
        this.props.refreshData('diamonds', ['color'], this.concatValues());
      });
    } else if(color == 'l') {
      this.setState({ l: !this.state.l }, () => {
        this.props.refreshData('diamonds', ['color'], this.concatValues());
      });
    } else if(color == 'm') {
      this.setState({ m: !this.state.m }, () => {
        this.props.refreshData('diamonds', ['color'], this.concatValues());
      });
    }
  }

  selectAll() {
    this.setState({
      d: true,
      e: true,
      f: true,
      g: true,
      h: true,
      i: true,
      j: true,
      k: true,
      l: true,
      m: true,
    }, () => {
      this.props.refreshData('diamonds', ['color'], this.concatValues());
    });
  }

	render() {
		return <div className='ColorRadios'>
			<div className='radioRowWrapper'>
        <div 
          className={this.state.d ? 'radioItem selected' : 'radioItem'}
          onClick={() => this.toggleColor('d')}>
          <div className='radioPip'>D</div>
        </div>
        <div 
          className={this.state.e ? 'radioItem selected' : 'radioItem'}
          onClick={() => this.toggleColor('e')}>
          <div className='radioPip'>E</div>
        </div>
        <div 
          className={this.state.f ? 'radioItem selected' : 'radioItem'}
          onClick={() => this.toggleColor('f')}>
          <div className='radioPip'>F</div>
        </div>
        <div 
          className={this.state.g ? 'radioItem selected' : 'radioItem'}
          onClick={() => this.toggleColor('g')}>
          <div className='radioPip'>G</div>
        </div>
        <div 
          className={this.state.h ? 'radioItem selected' : 'radioItem'}
          onClick={() => this.toggleColor('h')}>
          <div className='radioPip'>H</div>
        </div>
        <div 
          className={this.state.i ? 'radioItem selected' : 'radioItem'}
          onClick={() => this.toggleColor('i')}>
          <div className='radioPip'>I</div>
        </div>
        <div className='lineBreak'></div>
        <div 
          className={this.state.j ? 'radioItem selected' : 'radioItem'}
          onClick={() => this.toggleColor('j')}>
          <div className='radioPip'>J</div>
        </div>
        <div 
          className={this.state.k ? 'radioItem selected' : 'radioItem'}
          onClick={() => this.toggleColor('k')}>
          <div className='radioPip'>K</div>
        </div>
        <div 
          className={this.state.l ? 'radioItem selected' : 'radioItem'}
          onClick={() => this.toggleColor('l')}>
          <div className='radioPip'>L</div>
        </div>
        <div 
          className={this.state.m ? 'radioItem selected' : 'radioItem'}
          onClick={() => this.toggleColor('m')}>
          <div className='radioPip'>M</div>
        </div>
        <div className={'radioItem allItem'} onClick={::this.selectAll}>
          <div className={'radioPip allPip'}>All</div>
        </div>
        <div className='allLinkWrapper' style={{display: 'none'}}>
          <div className='allLink' onClick={::this.selectAll}>Select All</div>
        </div>
      </div>
		</div>;
	}
}
export default ColorRadios;

function mapStateToProps(state) {
  return {

  };
}

export const ColorRadiosContainer = connect(
  mapStateToProps,
  allActionCreators
)(ColorRadios);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/filterElements/ColorRadios.jsx